<template>
  <div>
    <el-dialog
      :visible.sync="innerVisible"
      :title="title"
      width="725px"
      :close-on-click-modal="false"
      custom-class="cooperation-branch-dialog"
      @close="innerVisible=false"
    >
      <div class="app-main-inner-row row-grid" style="padding: 0;">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :style="{width:'100%',height:'250px'}"
        />
      </div>
      <span slot="footer" style="padding:10px;">
        <el-button type="primary" @click="handleClose">{{ $t('CargoMsg.Cargo_Close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { getCooperateStatusLog } from '@/api/booking/jobCooperate'

export default {
  name: 'CooperateStatusLogDialog',
  props: {
    visible: { type: Boolean, required: true },
    uuid: { type: String, required: true },
    statusType: { type: Number, required: true },
    statusTypeDesc: { type: String, default: '' }
  },
  data() {
    return {
      loading: false,
      innerVisible: false,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [
        { headerName: this.$t('CargoMsg.Cargo_OperateBy'), field: 'createdBy', width: 120, sortable: false,
          cellStyle: { textAlign: 'center' }
        },
        { headerName: this.$t('CargoMsg.Cargo_CooperateLogOperation'), field: 'operation', width: 120, sortable: false,
          cellStyle: { textAlign: 'center' }
        },
        { headerName: this.$t('CargoMsg.Cargo_CooperateLogState'), field: 'state', width: 140, sortable: false,
          cellRenderer: (params) => {
            return this.statusType === 1 ? ColumnUtils.cooperateStatusLabelFunc(params.value) : ColumnUtils.businessStatusLabelFunc(params.value)
          },
          cellStyle: { textAlign: 'center' }
        },
        { headerName: this.$t('CargoMsg.Cargo_OperateTime'), field: 'dateCreated', width: 140, sortable: false,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_CooperateLogContent'), field: 'content', width: 160, sortable: false }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: []
    }
  },
  computed: {
    title() {
      return this.statusTypeDesc
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  methods: {
    toQuery() {
      if (!this.uuid) return
      this.rowData = []
      this.loading = getLoading()
      getCooperateStatusLog({ 'uuid': this.uuid, 'statusType': this.statusType }).then(res => {
        this.rowData = res.data
      }).finally(() => {
        this.loading.close()
      })
    },
    handleClose() {
      this.innerVisible = false
    }
  }
}
</script>
<style lang="scss">
.cooperation-branch-dialog {
  .el-dialog__body {
    padding: 10px !important;
  }
}
</style>
